import React, { useState, useEffect, useRef }       from 'react';
import ExtraChargeService                          from 'services/extra-charge.service';
import AuthService                                  from 'services/auth.service';
import { Form, Modal, Button }                      from "react-bootstrap";
import IconRemove                                   from 'assets/icons/Remove.svg';
import IconPlus                                     from 'assets/icons/Plus Circle.svg';
import ExtraChargesConfirmModal                     from "./ExtraChargesConfirmModal";
import ExtraChargesDetails                          from "./ExtraChargesDetails";
import 'react-day-picker/lib/style.css';

function ExtraCharge({chat}) {
  const defaultExtraCharge = {
    "name": '',
    "remarks": '',
    "price": '',
  }
  const isExtraChargesCancelled = useRef(false);
  const isExtraChargedCancelled = useRef(false);
  const [extraCharged, setExtraCharged] = useState(chat?.extra_charge?.extra_charge_id); 
  const [noExtraCharge, setNoExtraCharge] = useState(!chat.extra_charge.enabled);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [extraCharges, setExtraCharges] = useState([defaultExtraCharge]);
  const [showExtraChargesConfirm, setShowExtraChargesConfirm] = useState(false);
  const [erx, setErx] = useState({});

  const ExtraChargeConfirmationModal = () => {
    return (
      <Modal show={showConfirmation} onHide={() => {setShowConfirmation(false)}} backdrop="static" keyboard={false}>
        <Modal.Body>
          By checking <b>"No extra charges needed for this consultation"</b>, you are indicating that there's no extra charges needed for this consultation. Do note that this action is irreversible. Please confirm.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {setShowConfirmation(false)}}>Cancel</Button>
          <Button variant="danger" onClick={confirmNoExtraCharge}>Yes, Confirm</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  useEffect(() => {
    if(!extraCharged){
      const params = {
        extra_charge: !noExtraCharge
      }
      ExtraChargeService.requireExtraCharge(chat.id, params).then(
        (data) => {
          // after extra charge required updated
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }
    return () => {
      isExtraChargesCancelled.current = true;
    };
  }, [noExtraCharge]); // eslint-disable-line

  useEffect(() => {
    if(extraCharged){
      ExtraChargeService.getExtraCharges(extraCharged).then(
        (data) => {
          setErx(data);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }
    return () => {
      isExtraChargedCancelled.current = true;
    };
  }, [extraCharged]); // eslint-disable-line

  const confirmNoExtraCharge = () => {
    setNoExtraCharge(true);
    setShowConfirmation(false);
  }  

  const handleSetNoExtraCharge = (e) => {
    if(e.target.checked){
      setShowConfirmation(true);
    }else{
      setNoExtraCharge(false);
    }
  }

  const extraChargesForm = () => {
    const handleMedChange = (e, index) => {
      const newState = extraCharges.map((obj, i) => {
        if (i === index) {
          return {...obj, [e.target.name]: e.target.value};
        }
        return obj;
      });

      setExtraCharges(newState);
    }

    const removeExtraCharge = (index) => {
      setExtraCharges((prevState) => {
        return prevState.filter(
          (el, i) => i !== index
        )
      });
    }

    return (
      <div>
        {
          extraCharges.map((medicine, index) => {
            return <div className="d-flex medicine-row" key={`medicine_${index}`}>
              <Form.Control className="med-field col-12 col-lg-3" name="name" placeholder="Item Name" onChange={(e) => {handleMedChange(e, index)}} value={medicine.name} maxLength="150"/>
              <Form.Control className="med-field col-12 col-lg-6" as="textarea" name="remarks" placeholder="Please indicate what this charges is for or if it needs any other additional instructions." value={medicine.remarks} onChange={(e) => {handleMedChange(e, index)}}/>
              <Form.Control className="med-field col-12 col-lg-2" type="number" name="price" placeholder="Price" onChange={(e) => {handleMedChange(e, index)}} min={0.01} value={medicine.price}/>
              {index > 0 && <button className="btn btn-link col-12 col-lg-1" onClick={() => {removeExtraCharge(index)}}><img src={IconRemove} alt="delete-icon"/></button>}
            </div>
          })
        }
        <button className="btn btn-link text-danger add-med-btn" onClick={addExtraCharge}>
          <img src={IconPlus} alt="plus-icon" className="plus-icon"/>Add An Item
        </button>
        <hr />
        <div className="d-flex medicine-row">
          <div className="col-lg-10"></div>
          <div className="col-lg-1 px-1 ml-5 text-nowrap text-center">RM {getTotal(extraCharges)}</div>
          <div className="col-lg-1"></div>
        </div>
        <hr />
      </div>
    );
  }

  const getTotal = (_tempMed) => {
    var total = 0;
    _tempMed?.forEach(m => {
      total += parseFloat(m.price) || 0
    })
    return total.toFixed(2) || '0.00'
  }

  const addExtraCharge = () => {
    setExtraCharges((prevState) => {
      return [...prevState, defaultExtraCharge];
    });
  }

  // extraCharges confirmation
  const extraChargesConfirm = () => {
    // check if everything not null 
    var error = false;
    const excludeKeys = ['remarks']
    
    // if(!e_delivery){
    //   excludeKeys.push('price');
    // }
    extraCharges.forEach(med => {
      Object.keys(med).forEach((key, index) => {
        if(!excludeKeys.includes(key) && (med[key] === null || med[key] === '' || med[key] === 0)){
          error = true;
          return;
        }
      })
      if(error) return;
    })

    if(error){
      alert("Please complete the form before submitting.");
    }else{
      setShowExtraChargesConfirm(true);
    }
  }

  return (
    <div className="prescription extra-charges">
      <h6 className="p-2">Extra Charges</h6>
      {extraCharged ? <ExtraChargesDetails extraCharges={erx?.items} getTotal={getTotal} erx={erx}/> : (
        <>
          <Form.Check inline>
            <Form.Check.Input 
              id="extra_charge" 
              type="checkbox" 
              checked={noExtraCharge}
              onChange={(e) => {handleSetNoExtraCharge(e)}} />
            <Form.Check.Label htmlFor="extra_charge">No extra charges for this consultation</Form.Check.Label>
          </Form.Check>
          {!noExtraCharge && 
            <>
              {extraChargesForm()}
              <div className="d-flex justify-content-between align-items-end">
                <div><button className="btn save-prescription-btn" onClick={() => extraChargesConfirm()}>Save & Send</button></div>
              </div>
            </>
          }
          <ExtraChargeConfirmationModal />
          <ExtraChargesConfirmModal setShowExtraChargesConfirm={setShowExtraChargesConfirm} showExtraChargesConfirm={showExtraChargesConfirm} extraCharges={extraCharges} getTotal={getTotal} chat_id={chat.id} setExtraCharged={setExtraCharged}/>
        </>
      )}
    </div>
  )
}

export default ExtraCharge;